module.exports = __webpack_public_path__ + "flowers3.ef92974b31b48badf0ff.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animations/flowers3.gif
// module id = ./src/assets/images/animations/flowers3.gif
// module chunks = main